
import { useEffect, useState } from "react";
import { Card, Grid } from "@mui/material";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import ImagemEdit from "../../utils/imagemEdit";
import DateHora from "../../utils/dateHora";
import Delete from "../../utils/delete";
import ChangeDirectorTecnico from "../gestDirectorTecnico/changeDirectorTecnico";
import ReenviarLinkReprovacao from "../departamentos/dlif/licenciamento/reenviarLinkReprovacao";
import InfoFieldGroup from "../../utils/InfoField/InfoFieldGroup";
import api from "../../services/api";
import { useSelector } from "react-redux";
import EnviarNotificacao from "../../utils/enviarNotificacao";
// import { useMatch } from 'react-router-dom';

export default function FichaEstabelecimento(props) {
    const user = useSelector(state => state.account.user);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [editDados, setEditDados] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const [dadosEstabelecimento, setDadosEstabelecimento] = useState(props.estabelecimento)
    const [openEditLogo, setOpenEditLogo] = useState(false);
    const [open, setOpen] = useState(false);
    const [changeDirectorTecnico, setChangeDirectorTecnico] = useState(false);
    const [openReenviarLinkReprovacao, setOpenReenviarLinkReprovacao] = useState(false);
    const [openEnviarNotificao, setOpenEnviarNotificacao] = useState(false);
    const [tipoEstabelecimentos, setTipoEstabelecimentos] = useState([])
    const [municipios, setMunicipios] = useState([]);
    const [provincias, setProvincias] = useState([]);
    // const match = useMatch('/admin/gestor-licenciados/*');
    // const isGestorLicenciados = Boolean(match);
    // console.log(dadosEstabelecimento)


    useEffect(() => {
        if (isEdit) {
            api.get('/provincias')
                .then(res => {
                    setProvincias(res.data.provincias);

                }).catch(err => '')
        }
        api.get('/tipo-estabelecimentos')
            .then(res => {
                // console.log(res)
                setTipoEstabelecimentos(res.data.tipoEstabelecimentos);
            }).catch(err => '')
    }, [isEdit])

    useEffect(() => {
        if (editDados?.provinciaId) {
            api.get(`/municipios-by-provincia/${editDados?.provinciaId}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                    setEditDados((prev) => ({ ...prev, provincia: res.data.provincia.designacao }));
                }).catch(err => 'console.log(err)')
        }
    }, [editDados?.provinciaId])


    const submitEdit = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        await api.put('/estabelecimento/edit', { ...editDados, 'estabelecimentoId': dadosEstabelecimento._id, 'userId': user?._id ?? '' })
            .then(res => {
                setDadosEstabelecimento(res.data.estabelecimento)
                setOpen(false)
                setMessageSuccess(res.data.msg)
                setIsEdit(false)

            }).catch(err => {
                // console.log(err)
                setOpen(false)
                setMessageError(err.response.data.message)
            })
    }

    return (
        <Card style={{ padding: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                menu={props?.menu ?? true}
                configArea={'fichaEstabelecimento'}
                title={isEdit ? 'EDITAR DADOS' : props.title ? props.title : 'DADOS DO ESTABELECIMENTO'}
                estabelecimento={dadosEstabelecimento}
                editDados={isEdit}
                setEditDados={setIsEdit}
                delete={setOpen}
                setChangeDirectorTecnico={setChangeDirectorTecnico}
                setOpenReenviarLinkReprovacao={setOpenReenviarLinkReprovacao}
                setOpenEnviarNotificacao={setOpenEnviarNotificacao}
            />

            <Delete
                // open={open}
                setOpen={setOpen}
                url={'/estabelecimento/delete'}
                msg={`Tem certeza que deseja eliminar o Estabelecimento ${dadosEstabelecimento?.nome}`}
                id={dadosEstabelecimento._d}
            />

            <ChangeDirectorTecnico
                estabelecimento={dadosEstabelecimento}
                open={changeDirectorTecnico}
                setOpen={setChangeDirectorTecnico}
            />

            <ReenviarLinkReprovacao
                estabelecimento={dadosEstabelecimento}
                openReenviarEmail={openReenviarLinkReprovacao}
                setOpenReenviarEmail={setOpenReenviarLinkReprovacao}
                setMessageSuccess={setMessageSuccess}
                setMessageError={setMessageError}
            />

            <EnviarNotificacao
                estabelecimento={dadosEstabelecimento}
                openReenviarEmail={openEnviarNotificao}
                setOpenReenviarEmail={setOpenEnviarNotificacao}
                setMessageSuccess={setMessageSuccess}
                setMessageError={setMessageError}
            />

            <Grid container>

                {/* CASO ESTIVER NO GESTOR DE LICENCIADOS NAO PRECISA EXIBIR A IMAGEM PORQUE NA NAVE LATERAL TA TEM */}
                {/* {!isGestorLicenciados && */}

                {/* <Grid item xs={12} sm> */}
                {!isEdit &&
                    <Grid item marginRight={2}>
                        <ImagemEdit
                            data={dadosEstabelecimento}
                            url={'/estabelecimento/change-logo'}
                            local={'estabelecimentoId'}
                            setOpenEditLogo={setOpenEditLogo}
                            openEditLogo={props?.location === 'site' ? false : openEditLogo}
                        />
                    </Grid>
                }

                {/* < Grid item xs={12} sm={isEdit ? 12 : 8}> */}
                {dadosEstabelecimento.status === 'Não Licenciado' ?
                    <Grid xs item>
                        <InfoFieldGroup
                            editable={props?.editable}
                            submit={submitEdit}
                            data={editDados}
                            // handleChange={handleChange}
                            setIsEdit={setIsEdit}
                            isEdit={isEdit}
                            load={open}
                            fields={
                                [
                                    { label: 'Estado', value: dadosEstabelecimento?.status, editable: false, },
                                    { label: 'Nome', value: dadosEstabelecimento?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                    { label: 'E-mail', value: dadosEstabelecimento?.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                                    { label: 'Provincia', value: dadosEstabelecimento?.provincia, key: 'provinciaId', type: 'select', options: provincias, onChange: (v) => setEditDados({ ...editDados, provinciaId: v.target.value }) },
                                    { label: 'Município', value: dadosEstabelecimento?.municipio, key: 'municipio', type: 'select', options: municipios, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                                    { label: 'Bairro', value: dadosEstabelecimento?.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                                    { label: 'Rua / Avenida', value: dadosEstabelecimento?.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },
                                ]
                            } />
                    </Grid>
                    :
                    <Grid xs item spacing={2}>
                        <InfoFieldGroup
                            editable={props?.editable}
                            submit={submitEdit}
                            data={editDados}
                            // handleChange={handleChange}
                            setIsEdit={setIsEdit}
                            isEdit={isEdit}
                            load={open}
                            fields={
                                [
                                    { label: 'Estado', value: dadosEstabelecimento?.status, editable: false, },
                                    { label: 'Nome', value: dadosEstabelecimento?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                    { label: 'Estabelecimento', key: 'tipoId', type: 'select', options: tipoEstabelecimentos, value: dadosEstabelecimento?.tipo?.designacao, onChange: (v) => setEditDados({ ...editDados, tipoId: v.target.value }) },
                                    { label: 'E-mail', value: dadosEstabelecimento?.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                                    { label: 'Carteira do Arquitecto', value: dadosEstabelecimento?.carteiraArquitecto, key: 'carteiraArquitecto', onChange: (v) => setEditDados({ ...editDados, carteiraArquitecto: v.target.value }), editable: false, },
                                    { label: 'Número de processo', value: dadosEstabelecimento?.numeroProcesso, key: 'numeroProcesso', onChange: (v) => setEditDados({ ...editDados, numeroProcesso: v.target.value }), editable: false, },
                                    { label: 'Número de entrada', value: dadosEstabelecimento?.numeroEntrada, key: 'numeroEntrada', onChange: (v) => setEditDados({ ...editDados, numeroEntrada: v.target.value }), editable: false, },
                                    { label: 'Data de entrada', value: dadosEstabelecimento?.dataEntrada ?? <DateHora date={dadosEstabelecimento?.createdAt} />, editable: false, },
                                    { label: 'Provincia', value: dadosEstabelecimento?.provincia, key: 'provinciaId', type: 'select', options: provincias, onChange: (v) => setEditDados({ ...editDados, provinciaId: v.target.value }) },
                                    { label: 'Município', value: dadosEstabelecimento?.municipio, key: 'municipio', type: 'select', options: municipios, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                                    { label: 'Bairro', value: dadosEstabelecimento?.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                                    { label: 'Rua / Avenida', value: dadosEstabelecimento?.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },
                                ]
                            } />
                    </Grid>
                }
            </Grid>
        </Card>
    )
}